/* eslint-disable prefer-template */
/**
 * Layer Type: HP Resource Slider
 *
 * @package  embark
 * @since    1.0.0
 */

/**
 * Import dependencies.
 */
import $ from 'jquery';
import 'slick-carousel';

/**
 * Do synchronized slick sliders.
 */
function initSliders() {
	$('.testimonials-carousel').slick({
		dots: true,
		infinite: true,
		fade: true,
		arrows: true,
		autoplay: false,
	});
}

function initNewsSlider() {
	const newsSlider = $('.news-listings.slick-initialized');
	if (newsSlider.length < 1 && window.matchMedia('(max-width: 834px)').matches) {
		$('.news-listings').slick({
			infinite: true,
			mobileFirst: true,
			arrows: true,
			responsive: [
				{
					breakpoint: 834,
					settings: 'unslick',
				},
			],
		});
	}
}

function initDivisionsSlider() {
	const divsSlider = $('.divisions-slider.slick-initialized');
	if (divsSlider.length < 1 && window.matchMedia('(max-width: 834px)').matches) {
		$('.divisions-slider').slick({
			infinite: true,
			mobileFirst: true,
			arrows: true,
			responsive: [
				{
					breakpoint: 834,
					settings: 'unslick',
				},
			],
		});
	}
}

window.addEventListener('resize', () => {
	initNewsSlider();
	initDivisionsSlider();
});
window.addEventListener('DOMContentLoaded', () => {
	initSliders();
	initNewsSlider();
	initDivisionsSlider();
});
